class HistoriqueController {

  constructor() {
    var that = this;
    that.deroule = false;

    that.voirPlus = function () {
      that.deroule = true;
    };
    that.voirMoins = function () {
      that.deroule = false;
    };
  }

}

HistoriqueController.$inject = [];

module.exports = HistoriqueController;



// WEBPACK FOOTER //
// ./src/app/components/historique/historique.controller.js